import React from 'react';
import { FIORI_THEME as T } from './Layout';
import { T as Tds } from '../../design-system/tokens';
import { APP_NAME } from '../../config/brand';

// Fiori shell bar: brand-green top bar that replaces the sidebar when ?ui=fiori
// is active. Stateless — Layout passes user + handlers.
export default function FioriShellBar({ user, unreadCount = 0, onBell, onSearch, onExit }) {
  const initials = (user?.name || user?.email || 'U')
    .split(/[\s@.]+/).filter(Boolean).map((w) => w[0]).join('').slice(0, 2).toUpperCase();
  return (
    <div style={{ height: 44, background: T.shell, color: T.shellText, display: 'flex',
      alignItems: 'center', gap: 14, padding: '0 14px', position: 'sticky', top: 0, zIndex: 60, flexShrink: 0 }}>
      <span style={{ fontSize: Tds.type.lg, opacity: 0.9 }}>▦</span>
      <span style={{ fontWeight: 700, fontSize: Tds.type.md, letterSpacing: '0.2px' }}>{APP_NAME}</span>
      <button onClick={onSearch} style={{ marginLeft: 'auto', background: 'rgba(255,255,255,0.16)',
        border: '1px solid rgba(255,255,255,0.25)', borderRadius: 6, padding: '6px 12px',
        color: '#EAF5EE', fontSize: Tds.type.sm, cursor: 'pointer' }}>⌕ Search</button>
      <button onClick={onBell} data-notif-toggle="1" aria-label="Notifications" style={{ width: 30, height: 30,
        borderRadius: '50%', background: 'rgba(255,255,255,0.14)', border: 'none', color: '#fff',
        cursor: 'pointer', position: 'relative' }}>🔔
        {unreadCount > 0 && <span style={{ position: 'absolute', top: -2, right: -2, background: T.statusNeg,
          borderRadius: 8, fontSize: Tds.type.xxs, fontWeight: 800, padding: '0 4px' }}>{unreadCount}</span>}
      </button>
      <button onClick={onExit} title="Exit Fiori preview" style={{ background: 'none', border: 'none',
        color: '#EAF5EE', cursor: 'pointer', fontSize: Tds.type.xs }}>Classic ↩</button>
      <span style={{ width: 30, height: 30, borderRadius: '50%', background: '#0E3B27', display: 'flex',
        alignItems: 'center', justifyContent: 'center', fontSize: Tds.type.xs, fontWeight: 700 }}>{initials}</span>
    </div>
  );
}
